import React from 'react';
import {StepImplementationProps, StepState} from '../../../../../types/checkoutApp.types';
import {AdditionalDetailsStepOpen} from './Components/AdditionalDetailsStepOpen';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {withAdditionalDetailsData} from './Components/WithAdditionalDetailsData';
import {DynamicStep, DynamicStepComponentProps} from '../../StepsManager/Components/DynamicStep';
import {StepHeader} from '../../StepsManager/Components/StepHeader';

export enum AdditionalDetailsStepDataHook {
  root = 'AdditionalDetailsStep.root',
  header = 'AdditionalDetailsStep.header',
  collapsed = 'AdditionalDetailsStep.collapsed',
  open = 'AdditionalDetailsStep.open',
}

const WrappedAdditionalDetailsStepOpen = withAdditionalDetailsData(AdditionalDetailsStepOpen);

export const AdditionalDetailsStepInternal = ({index}: DynamicStepComponentProps) => {
  const {
    stepsManagerStore: {stepsList},
    checkoutStore: {cart},
  } = useControllerProps();

  const stepState = stepsList[index]?.state;
  const getTitle = (): string => {
    if (stepState !== StepState.EMPTY && cart.forms.length > 1) {
      return `***Additional Details (${cart.forms.length})***`;
    }

    return '***Additional Details***';
  };

  const titleText = getTitle();

  return (
    <>
      <StepHeader index={index} label={titleText} dataHook={AdditionalDetailsStepDataHook.header} />
      {stepState === StepState.OPEN && <WrappedAdditionalDetailsStepOpen />}
      {stepState === StepState.COLLAPSED && <div data-hook={AdditionalDetailsStepDataHook.collapsed} />}
    </>
  );
};

export const AdditionalDetailsStep = ({index}: StepImplementationProps) => {
  return (
    <DynamicStep
      index={index!}
      dataHook={AdditionalDetailsStepDataHook.root}
      component={AdditionalDetailsStepInternal}
    />
  );
};
